export default {
    data : {
        token: '',
        userName: '',
        roleId: ''
    },
    getUserData() {
        this.data = JSON.parse(window.localStorage.getItem("sessions_key"))
        return this.data
    },
    getToken() {
        if(this.getUserData()) {
            return this.getUserData().token
        }
        return null
    },
    isAdmin: window.localStorage.getItem("sessions_key") == null ? false : JSON.parse(window.localStorage.getItem("sessions_key")).roleId == 1 ? true:false,
    isCw: window.localStorage.getItem("sessions_key") == null ? false : JSON.parse(window.localStorage.getItem("sessions_key")).roleId == 7 ? true:false,
    isKf: window.localStorage.getItem("sessions_key") == null ? false : JSON.parse(window.localStorage.getItem("sessions_key")).roleId == 4 ? true:false,
    isFP: window.localStorage.getItem("sessions_key") == null ? false : JSON.parse(window.localStorage.getItem("sessions_key")).roleId == 6 ? true:false,
}


// WEBPACK FOOTER //
// ./src/js/user.js